import { useContext } from 'react';
import { UserContext, UserActionsContext } from '../context/userContext';

export const useUser = () => {
  const context = useContext(UserContext);

  if (!context)
    throw new Error('useAuth must be used within a AuthContextProvider');

  return context;
};

export const useUserActions = () => {
  const context = useContext(UserActionsContext);

  if (!context)
    throw new Error(
      'useAuthActions must be used within a AuthActionsContextProvider',
    );

  return context;
};
